import { render } from "./ProductsWithMinimumStock.vue?vue&type=template&id=eea91338"
import script from "./ProductsWithMinimumStock.vue?vue&type=script&lang=js"
export * from "./ProductsWithMinimumStock.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__